import React, { useContext, useState } from 'react';
import AnnonceContext from '../../../../../contexts/AnnonceContext';

export default function Textbox({ name, isSecret, attributeValue = "" }) {
  const { setFormAttributes } = useContext(AnnonceContext);
  const [value, setValue] = useState(attributeValue || '');

  return (
    <div className="w-full">
      <input
        type="text"
        placeholder={name}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          setFormAttributes((formAttributes) => [
            ...formAttributes.filter((att) => att.attribute !== name),
            {
              attribute: name,
              attributeValue: e.target.value,
              isSecret: isSecret,
            },
          ])
        }}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1b9faa] focus:border-transparent"
      />
    </div>
  );
}
